export const ROLE_ID = {
  CONSUMER: '1',
  RM: '2',
  ADMIN: '3',
  POSP: '4',
  DATA_OPERATOR: '5',
  TELE_OPERATOR: '6',
  ROLE_7: '7',
  ROLE_8: '8',
  AV: '9',
  LG: '10',
  TELE_MARKETER: '11',
  /** Review & Pay resume-link customer session (B2B channel, not full B2C). */
  REVIEW_PAY: '14',
};
